App.SettingsStaffController = Em.Controller.extend
  restaurants: []

  businessRoles: Ember.computed ->
    @store.find('business_role')